<template>
  <section class="aura-services">
    <div class="container">
      <!-- Header -->
      <div class="services-header">
        <p class="section-eyebrow">{{ $t('whatWeOffer') }}</p>
        <h2 class="section-title">{{ $t('OurServices') }}</h2>
      </div>

      <!-- Cards -->
      <div class="services-grid">
        <div class="service-card">
          <div class="service-img-wrap">
            <img src="img/sign.png" alt="Contract renewal" class="service-img" />
            <div class="service-img-overlay"></div>
            <span class="service-tag">Renewal</span>
          </div>
          <div class="service-body">
            <h3 class="service-title">{{ $t('Contract') }}</h3>
            <p class="service-desc">{{ $t('ContractDesc') }}</p>
            <router-link to="/services" class="service-link">
              {{ $t('getStarted') }}
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 10h12M11 5l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </router-link>
          </div>
        </div>

        <div class="service-card service-card--featured">
          <div class="service-img-wrap">
            <img src="img/oversea.png" alt="Overseas helpers" class="service-img" />
            <div class="service-img-overlay"></div>
            <span class="service-tag service-tag--dark">Most Popular</span>
          </div>
          <div class="service-body">
            <h3 class="service-title">{{ $t('Oversea') }}</h3>
            <p class="service-desc">{{ $t('OverseaDesc') }}</p>
            <router-link to="/services" class="service-link">
              {{ $t('getStarted') }}
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 10h12M11 5l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </router-link>
          </div>
        </div>

        <div class="service-card">
          <div class="service-img-wrap">
            <img src="img/local.png" alt="Local helpers" class="service-img" />
            <div class="service-img-overlay"></div>
            <span class="service-tag">Local</span>
          </div>
          <div class="service-body">
            <h3 class="service-title">{{ $t('Local') }}</h3>
            <p class="service-desc">{{ $t('LocalDesc') }}</p>
            <router-link to="/services" class="service-link">
              {{ $t('getStarted') }}
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 10h12M11 5l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Pricing",
  props: {
    isGray: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.aura-services {
  background: #f8fafc;
  padding: 96px 0;
}

/* ── Header ── */
.services-header {
  margin-bottom: 56px;
}
.section-eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #C93380;
  margin-bottom: 10px;
}
.section-title {
  font-family: 'Playfair Display', Georgia, serif;
  font-size: clamp(26px, 3.5vw, 38px);
  font-weight: 500;
  color: #0A7A76;
  line-height: 1.2;
  margin: 0;
}

/* ── Grid ── */
.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  align-items: start;
}

/* ── Card ── */
.service-card {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04);
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.25s, transform 0.25s;
}
.service-card:hover {
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.1);
  transform: translateY(-4px);
}
.service-card--featured {
  border-color: #0A7A76;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.12);
}

/* ── Image area ── */
.service-img-wrap {
  position: relative;
  aspect-ratio: 4/3;
  overflow: hidden;
}
.service-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}
.service-card:hover .service-img {
  transform: scale(1.04);
}
.service-img-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(15,23,42,0.3) 0%, transparent 60%);
}
.service-tag {
  position: absolute;
  top: 14px;
  left: 14px;
  background: rgba(255,255,255,0.92);
  backdrop-filter: blur(8px);
  border-radius: 50px;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 700;
  color: #0A7A76;
  letter-spacing: 0.3px;
}
.service-tag--dark {
  background: #0A7A76;
  color: #fff;
}

/* ── Body ── */
.service-body {
  padding: 24px 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
}
.service-title {
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 18px;
  font-weight: 600;
  color: #0A7A76;
  margin: 0;
  line-height: 1.3;
}
.service-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.7;
  margin: 0;
  flex: 1;
}
.service-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #0A7A76;
  text-decoration: none !important;
  margin-top: 8px;
  transition: gap 0.2s;
}
.service-link svg {
  width: 16px;
  height: 16px;
  transition: transform 0.2s;
}
.service-link:hover { color: #475569; }
.service-link:hover svg { transform: translateX(4px); }

@media (max-width: 900px) {
  .services-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 600px) {
  .aura-services { padding: 64px 0; }
  .services-grid { grid-template-columns: 1fr; }
}
</style>
